import React from "react"
import styled from "styled-components"
import Grid from "../grid/Grid"

export default function BonusRound({ timer, state, handleCollect }: any) {
  function formatSecondsToMinutes(sec: any) {
    const minutes = Math.floor(sec / 60)
    const remainingSeconds = sec % 60
    return minutes + ":" + (remainingSeconds < 10 ? "0" : "") + remainingSeconds
  }
  return (
    <>
      <Text timer={timer > 10} state={state === "finished"}>
        <p className="title">Jackpot Round</p>
        <span>PLEASE SELECT CUBES TO DETERMINE YOUR WIN</span>
        <div className="timer-wrapper">
          <p className="timer">{formatSecondsToMinutes(timer)}</p>
        </div>
      </Text>
      <Grid handleCollect={handleCollect} />
    </>
  )
}

const greengradient =
  "linear-gradient(178.89deg,#28a909 14.22%,#309b17 69.01%,#208707 99.05%);"
const redgradient =
  "linear-gradient(178.89deg, #DB2E2E 14.22%, #E43030 36.3%, #F84444 99.05%);"

const Text = styled.div<{ timer: boolean; state: boolean }>`
  line-height: 70%;
  font-family: "Teko";
  font-style: normal;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 40px;
  .title {
    font-weight: 600;
    font-size: 34px;
    line-height: 1;
    background: linear-gradient(
      178.89deg,
      #1f3db6 14.22%,
      #2345ca 36.3%,
      #355aee 99.05%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 9px;
    pointer-events: none;
    /* text-fill-color: transparent; */
  }
  .timer-wrapper {
    background: rgba(28, 30, 36, 0.6);
    border-radius: 4px;
    width: 57px;
    margin: 18px auto 0;
    opacity: ${({ state }) => (state ? 0 : 1)};
    transition: opacity 0.3s linear;
  }
  .timer {
    padding: 6px;
    line-height: 1;
    font-size: 24px;
    background: ${({ timer }) => (timer ? greengradient : redgradient)};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  span {
    font-weight: 400;
    font-size: 14px;
    color: #868b9e;
    pointer-events: none;
  }
  @media only screen and (min-width: 768px) {
    margin-bottom: 50px;
    .title {
      font-size: 58px;
      margin-bottom: 15px;
    }
    span {
      font-size: 24px;
    }
  }
  @media only screen and (min-width: 1024px) and (max-height: 640px) {
    margin-bottom: 40px;
    .title {
      font-size: 34px;
      margin-bottom: 9px;
    }
    span {
      font-size: 14px;
    }
  }
`
